import Store from "../Models/Store";
import PageModel from "../Models/ViewModels/PageModel";
import StoreViewModel from "../Models/ViewModels/StoreViewModel";
import MakeRequest from "../Utilities/MakeRequest";

export function fetchStoresList(searchValue: string, sortValue: string, sortAscending: boolean, currentPage: number, pageSize: number): Promise<PageModel<StoreViewModel>> {
	return new Promise<PageModel<StoreViewModel>>((resolve, reject) => {
		new MakeRequest(`/api/Stores/search?searchValue=${searchValue}&SortValue=${sortValue}&SortAscending=${sortAscending}&Page=${currentPage}&Size=${pageSize}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function getStore(storeId: string): Promise<Store> {
	return new Promise<Store>((resolve, reject) => {
		new MakeRequest(`/api/stores/Get?id=${storeId}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function fetchCreateStoreModal(): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest('/DomainAdmin/Stores/Create')
			.send()
			.then(resolve, reject);
	});
}

export function createStore(store: Store): Promise<number> {
	return new Promise<number>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest('/api/Stores/Create', "Post", headers)
			.send(JSON.stringify(store))
			.then(resolve, reject);
	});
}

export function fetchUpdateStoreModal(storeId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Stores/update?id=${storeId}`)
			.send()
			.then(resolve, reject);
	});
}

export function updateStore(store: Store): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest('/api/Stores/Update', "Put", headers)
			.send(JSON.stringify(store))
			.then(resolve, reject);
	});
}

export function fetchDeleteStoreModal(storeId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Stores/delete?id=${storeId}`)
			.send()
			.then(resolve, reject);
	});
}

export function deleteStore(storeId: string): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest(`/api/Stores/Delete?id=${storeId}`, "delete", headers)
			.send()
			.then(resolve, reject);
	});
}

export function getStoresNames(storeIds: string[]): Promise<Map<string, string>> {
	return new Promise<Map<string, string>>((resolve, reject) => {
		new MakeRequest(`/api/Stores/GetNames?ids=${storeIds.join('&ids=')}`, "get")
			.send()
			.then((response: string) => {
				const parsed = JSON.parse(response);
				resolve(new Map(Object.entries(parsed)));
			}, reject);
	})
}

export function getStorePDFHTMLString(storeId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/api/Stores/GetStorePDFHTMLString?id=${storeId}`, "get")
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function sendStoreEmail(storeId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/api/Stores/SendStoreEmail?id=${storeId}`, "post")
			.send()
			.then(resolve, reject);
	});
}

export function fetchEConomicForm(storeId?: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Stores/EConomicForm?id=${storeId ?? ""}`)
			.send()
			.then(resolve, reject);
	});
}
